var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionalSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5460_2553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79053 23.2969C9.79053 23.6852 10.1053 24 10.4937 24H13.5062C13.8945 24 14.2093 23.6852 14.2093 23.2969V20.6875H9.79053V23.2969Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2719 10.3438H4.46873C4.28227 10.3438 4.10344 10.4179 3.97158 10.5497L0.205969 14.3153C0.0740625 14.4472 0 14.626 0 14.8125C0 14.999 0.0741094 15.1778 0.205969 15.3096L3.97158 19.0752C4.10344 19.2071 4.28227 19.2812 4.46873 19.2812H17.2718C17.6602 19.2812 17.975 18.9664 17.975 18.5781V11.0469C17.975 10.6585 17.6602 10.3438 17.2719 10.3438ZM11.7441 15.445C12.0187 15.7196 12.0187 16.1647 11.7441 16.4393C11.4701 16.7133 11.0249 16.7145 10.7497 16.4393L10.1172 15.8068L9.48473 16.4393C9.21023 16.7139 8.76497 16.714 8.49037 16.4393C8.21578 16.1648 8.21578 15.7196 8.49037 15.445L9.12281 14.8125L8.49028 14.18C8.21569 13.9054 8.21569 13.4602 8.49028 13.1856C8.76487 12.911 9.21005 12.911 9.48464 13.1856L10.1171 13.8181L10.7496 13.1856C11.0242 12.911 11.4694 12.911 11.744 13.1856C12.0186 13.4601 12.0186 13.9054 11.744 14.18L11.1115 14.8125L11.7441 15.445Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7939 3.97158L20.0283 0.205969C19.8965 0.0741094 19.7177 0 19.5312 0H6.72803C6.33971 0 6.0249 0.314812 6.0249 0.703125V8.23439C6.0249 8.6227 6.33971 8.93752 6.72803 8.93752H19.5311C19.7176 8.93752 19.8964 8.86341 20.0283 8.73155L23.7939 4.96594C23.9258 4.83408 23.9999 4.65525 23.9999 4.46878C23.9999 4.28231 23.9259 4.10344 23.7939 3.97158ZM16.6393 3.83625L14.3799 6.09562C14.2426 6.23292 14.0627 6.30159 13.8827 6.30159C13.7028 6.30159 13.5229 6.23297 13.3856 6.09562L12.2559 4.96594C11.9813 4.69134 11.9813 4.24617 12.2559 3.97158C12.5304 3.69698 12.9757 3.69698 13.2503 3.97158L13.8827 4.60406L15.645 2.84189C15.9196 2.5673 16.3647 2.56734 16.6393 2.84189C16.9139 3.11648 16.9139 3.56166 16.6393 3.83625Z",
    fill: "#C59C37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5460_2553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalSign);
export default __webpack_public_path__ + "static/media/directional-sign.d5b4a1d27755084b79f86152d6a34a36.svg";
export { ForwardRef as ReactComponent };